  import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const IciciHomeLoanEmiCalculator      = () => {
   const [loanAmount, setLoanAmount] = useState(5000000);
    const [interestRate, setInterestRate] = useState(7.5);
    const [loanTenure, setLoanTenure] = useState(20);
    const [monthlyEMI, setMonthlyEMI] = useState(0);
    const [totalInterest, setTotalInterest] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [amortizationSchedule, setAmortizationSchedule] = useState([]);
    const [activeYear, setActiveYear] = useState(null);
  
    const calculateEMI = () => {
      const principal = loanAmount;
      const annualInterest = interestRate / 100;
      const monthlyInterest = annualInterest / 12;
      const tenureInMonths = loanTenure * 12;
  
      const emi =
        (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
        (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);
  
      const totalAmount = emi * tenureInMonths;
      const totalInterest = totalAmount - principal;
  
      setMonthlyEMI(emi.toFixed(2));
      setTotalInterest(totalInterest.toFixed(2));
      setTotalAmount(totalAmount.toFixed(2));
  
      const schedule = [];
      let balance = principal;
      // let year = new Date().getFullYear();
      let currentYear = new Date().getFullYear();
  
      let currentMonth = 6;
  
      for (let i = 0; i < tenureInMonths; i++) {
        const interestForMonth = balance * monthlyInterest;
        const principalForMonth = emi - interestForMonth;
        balance -= principalForMonth;
  
        schedule.push({
          // month: i + 1,
          // year: year,
          month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
          year: currentYear + Math.floor((currentMonth + i) / 12),
          principalPaid: principalForMonth,
          interestPaid: interestForMonth,
          totalPayment: emi,
          balance: balance,
        });
  
        // if ((i + 1) % 12 === 0) {
        //   year++;
        // }
      }
  
      setAmortizationSchedule(schedule);
    };
  
    const handleLoanAmountChange = (e) => {
      const value = e.target.value;
      setLoanAmount(value === '' ? 0 : parseInt(value));
    };
  
    const handleInterestRateChange = (e) => {
      const value = e.target.value;
      setInterestRate(value === '' ? 0 : parseFloat(value));
    };
  
    const handleLoanTenureChange = (e) => {
      const value = e.target.value;
      setLoanTenure(value === '' ? 0 : parseInt(value));
    };
  
    const handleYearToggle = (year) => {
      setActiveYear(activeYear === year ? null : year);
    };
  
    const data = {
      labels: ['Principal Amount', 'Total Interest'],
      datasets: [
        {
          label: 'EMI Breakdown',
          data: [loanAmount, totalInterest],
          backgroundColor: ['#36A2EB', '#FF6384'],
        },
      ],
    };
    const categories = [
      { id: 1, name: 'Category 1', link: '/' },
      { id: 2, name: 'Category 2', link: '/' },
      { id: 3, name: 'Category 3', link: '/' },
      { id: 4, name: 'Category 4', link: '/' },
      // Add more categories as needed
    ];
  function Icon({ id, open }) {
      return (
          <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
          >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
      );
    }
    
    
      const [activeIndex, setActiveIndex] = useState(0);
    
       
      const faqs = [
        {
            "question": "What details are required for calculating ICICI Home Loan EMI?",
            "answer": "You need to enter the loan amount, interest rate, and loan tenure."
          },
          {
            "question": "Can I change the tenure and see the EMI impact instantly?",
            "answer": "Yes, the calculator updates the EMI as you adjust the tenure in real time."
          },
          {
            "question": "Does the EMI include taxes or processing fees?",
            "answer": "No, EMI includes only principal and interest. Taxes and fees are separate."
          },
          {
            "question": "Can I use this calculator for ICICI balance transfer loans?",
            "answer": "Yes, you can use it to estimate EMIs for refinanced or transferred loans."
          },
          {
            "question": "Is the calculator suitable for under-construction property loans?",
            "answer": "Yes, but it does not reflect pre-EMIs or moratorium periods."
          },
          {
            "question": "Can I plan prepayments using this tool?",
            "answer": "Yes, adjusting tenure or principal amount gives you a prepayment overview."
          },
          {
            "question": "Is the EMI fixed for the entire tenure?",
            "answer": "For fixed-rate loans, EMI remains constant. It varies with floating-rate loans."
          },
          {
            "question": "How accurate is the EMI output?",
            "answer": "The tool uses standard formulas for precise results. Bank fees may slightly alter final amounts."
          },
          {
            "question": "Can I save or share the EMI result?",
            "answer": "Yes, you can screenshot or copy the result for reference."
          },
          {
            "question": "Does my credit score affect the EMI?",
            "answer": "Indirectly, yes. A good score lowers interest rates and hence EMI."
          },
          {
            "question": "Is there a mobile version of the calculator?",
            "answer": "Yes, TheFinMaster calculator is mobile-responsive and works on all devices."
          },
          {
            "question": "What is the maximum tenure allowed for ICICI home loans?",
            "answer": "ICICI offers up to 30 years, but final tenure depends on eligibility."
          },
          {
            "question": "Can I use the calculator for joint home loans?",
            "answer": "Yes, enter the combined loan details. Eligibility and interest may vary."
          },
          {
            "question": "Will my EMI reduce after a part-prepayment?",
            "answer": "Yes, banks allow you to either reduce EMI or shorten tenure after prepayment."
          },
          {
            "question": "How can TheFinMaster help me beyond EMI calculation?",
            "answer": "We help you compare lenders, track eligibility, and choose the right loan product with ease."
          }
        ]
      const toggleAccordion = (index) => {
        if (activeIndex === index) {
            // If the clicked question is already expanded, collapse it
            setActiveIndex(null);
        } else {
            // If the clicked question is not expanded, expand it
            setActiveIndex(index);
        };
      }
    return (
      <>
  
  {/* <Helmet>
           <title>EMI Calculator for Home Loan, Car Loan &amp; Personal Loan in India | TheFinmaster</title>
          <meta  name='description' content='Home Loan EMI Calculator helps you calculate EMI of your housing loan required to pay for your dream home. Know about Online Home Loan EMI Calculator here! | TheFinmaster'/>
          <meta name='keywords' content='hdfc home loan calculator, home loan emi calculator, sbi home loan interest rate calculator, axis bank home loan calculator, lic home loan emi calculator, axis bank home loan emi calculator, icici bank housing loan calculator' />
          <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/home-loan-emi-calculator" />
          <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
          <meta name="robots" content="max-video-preview:-1" />
        </Helmet> */}
        <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
            <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </li>
          <li className="flex items-center">
            <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
            <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </li>
            <li className="flex items-center">
            <span className="text-gray-500 ">ICICI Home Loan EMI Calculator</span>
          </li> 
        
        </ol>
      </nav>
      <div className='py-4 '>
  
     
      <div className="container mx-auto p-4 shadow-xl rounded-md ">
        <h1 className="text-2xl font-bold mb-4"> ICICI Home Loan EMI Calculator</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Loan Amount</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  value={loanAmount}
                  onChange={handleLoanAmountChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
              </div>
              <input
                type="range"
                min="0"
                max="100000000"
                value={loanAmount}
                onChange={(e) => setLoanAmount(parseInt(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  max="100"
                  step="0.1"
                  value={interestRate}
                  onChange={handleInterestRateChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">{interestRate} %</span>
              </div>
              <input
                type="range"
                min="0"
                max="15"
                step="0.1"
                value={interestRate}
                onChange={(e) => setInterestRate(parseFloat(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
              <div className="flex items-center">
                <input
                  type="number"
                  min="0"
                  max="30"
                  value={loanTenure}
                  onChange={handleLoanTenureChange}
                  className="w-1/2 p-2 border rounded mr-2"
                />
                <span className="text-gray-700">{loanTenure} Yr</span>
              </div>
              <input
                type="range"
                min="0"
                max="30"
                value={loanTenure}
                onChange={(e) => setLoanTenure(parseInt(e.target.value))}
                className="w-full mt-2"
              />
            </div>
            <button
              onClick={calculateEMI}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Calculate
            </button>
          </div>
          <div>
            <div className="mb-4">
              <h2 className="text-xl font-bold">Results</h2>
              <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
              <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
              <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
              <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
            </div>
            <div>
              <h2 className="text-xl font-bold">Breakdown</h2>
              <div className="flex justify-center">
                <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6">
          <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
          {amortizationSchedule.length > 0 && (
            <div className="flex flex-col space-y-4">
              {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
                <div key={idx} className="mb-4 border rounded-md shadow-md">
                  <div
                    className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                    onClick={() => handleYearToggle(year)}
                  >
                    <span>{year}</span>
                    <span>{activeYear === year ? '-' : '+'}</span>
                  </div>
                  {activeYear === year && (
                    <div className="overflow-x-auto">
                      <table className="min-w-full bg-white rounded-md shadow-md text-center">
                        <thead>
                          <tr>
                            <th className="py-2 px-4 border-b">Month</th>
                            <th className="py-2 px-4 border-b">Principal Paid</th>
                            <th className="py-2 px-4 border-b">Interest Charged</th>
                            <th className="py-2 px-4 border-b">Total Payment</th>
                            <th className="py-2 px-4 border-b">Balance</th>
                          </tr>
                        </thead>
                        <tbody>
                          {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                            <tr key={idx}>
                              <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                              <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                              <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                              <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                              <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your ICICI Home Loan Payments with TheFinMaster’s EMI Calculator
          </h1>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Buying your dream home with the support of a home loan from ICICI Bank becomes a smarter financial decision when you can forecast your repayment obligations clearly. TheFinMaster’s ICICI Home Loan EMI Calculator allows you to do just that with precision and ease. With the ability to plan your monthly outflows, understand the loan structure, and explore how different variables affect your EMIs, this tool is your trusted companion in your home buying journey.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Home Loan EMI?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Home Loan EMI (Equated Monthly Instalment) is the fixed monthly payment you make to repay your home loan over a specified tenure. This payment includes both the principal amount and the interest. The EMI amount is determined by the loan amount, interest rate, and repayment tenure.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              In the early phase of your loan tenure, a significant portion of the EMI goes towards the interest component, whereas the principal portion increases gradually over time. EMIs ensure disciplined repayment while enabling you to enjoy your property as you pay over time.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the ICICI Home Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The ICICI Home Loan EMI Calculator from TheFinMaster is a user-friendly digital tool that helps you calculate your monthly EMIs in seconds. It considers essential variables like loan amount, interest rate, and loan tenure to generate an accurate monthly repayment figure.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This calculator removes all the guesswork, helping borrowers make informed decisions regarding their loan structure, monthly budget, and repayment capacity. Whether you're a first-time buyer or looking to refinance, this tool is essential for financial clarity.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s ICICI Home Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s ICICI EMI Calculator offers a range of benefits:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Precision and Accuracy:</strong> Get quick and reliable EMI results by inputting simple loan variables.</li>
              <li><strong>Easy Comparisons:</strong> Compare different tenures, interest rates, or loan amounts to find what suits your budget.</li>
              <li><strong>Budget Planning:</strong> Understand how EMIs impact your monthly expenses and manage your finances better.</li>
              <li><strong>Time-saving:</strong> Avoid complex manual calculations with this instant, automated tool.</li>
              <li><strong>Real-time Adjustments:</strong> Modify your inputs on the go and see how the EMI changes instantly.</li>
              <li><strong>Financial Preparedness:</strong> Evaluate the feasibility of the loan and be prepared for prepayment or foreclosure decisions.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the ICICI Home Loan EMI Calculator Work?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The ICICI Home Loan EMI Calculator uses the following formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Loan amount</li>
              <li>R = Monthly interest rate (annual interest rate divided by 12 and by 100)</li>
              <li>N = Loan tenure in months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              Suppose you take a home loan of ₹50,00,000 at an interest rate of 8.5% per annum for 20 years (240 months).<br />
              Loan Amount (P): ₹50,00,000<br />
              Annual Interest Rate: 8.5%<br />
              Monthly Interest Rate (R): 8.5 / 12 / 100 = 0.00708<br />
              Tenure (N): 240 months<br />
              EMI = [5000000 x 0.00708 x (1+0.00708)^240] / [(1+0.00708)^240 – 1] ≈ ₹43,391<br />
              Hence, your EMI will be approximately ₹43,391.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortisation schedule is a complete breakdown of your loan repayment over time. It shows how much of each EMI goes towards interest and principal repayment. In the initial years, interest payments are higher, and gradually, the principal component increases. This transparency helps you plan prepayments and track your loan repayment timeline effectively.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>12-Month Amortisation Schedule (Example)</strong><br />
              For a ₹50,00,000 home loan at 8.5% interest rate over 20 years:
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Outstanding (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,417</td>
                    <td className="border px-4 py-2">7,974</td>
                    <td className="border px-4 py-2">49,92,026</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,444</td>
                    <td className="border px-4 py-2">7,947</td>
                    <td className="border px-4 py-2">49,84,079</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,471</td>
                    <td className="border px-4 py-2">7,920</td>
                    <td className="border px-4 py-2">49,76,159</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,497</td>
                    <td className="border px-4 py-2">7,894</td>
                    <td className="border px-4 py-2">49,68,265</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,524</td>
                    <td className="border px-4 py-2">7,867</td>
                    <td className="border px-4 py-2">49,60,398</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,551</td>
                    <td className="border px-4 py-2">7,840</td>
                    <td className="border px-4 py-2">49,52,558</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,577</td>
                    <td className="border px-4 py-2">7,814</td>
                    <td className="border px-4 py-2">49,44,744</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,604</td>
                    <td className="border px-4 py-2">7,787</td>
                    <td className="border px-4 py-2">49,36,957</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,630</td>
                    <td className="border px-4 py-2">7,761</td>
                    <td className="border px-4 py-2">49,29,196</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,656</td>
                    <td className="border px-4 py-2">7,735</td>
                    <td className="border px-4 py-2">49,21,461</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,683</td>
                    <td className="border px-4 py-2">7,708</td>
                    <td className="border px-4 py-2">49,13,753</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">43,391</td>
                    <td className="border px-4 py-2">35,709</td>
                    <td className="border px-4 py-2">7,682</td>
                    <td className="border px-4 py-2">49,06,071</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI  (₹)</th>
          <th className="border px-4 py-2 text-left"> Interest   (₹)</th>
          <th className="border px-4 py-2 text-left">Principal(₹)</th>
          <th className="border px-4 py-2 text-left">Outstanding  (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
          ["1", "43,391", "35,417", "7,974", "49,92,026"],
          ["2", "43,391", "35,444", "7,947", "49,84,079"],
          ["3", "43,391", "35,471", "7,920", "49,76,159"],
          ["4", "43,391", "35,497", "7,894", "49,68,265"],
          ["5", "43,391", "35,524", "7,867", "49,60,398"],
          ["6", "43,391", "35,551", "7,840", "49,52,558"],
          ["7", "43,391", "35,577", "7,814", "49,44,744"],
          ["8", "43,391", "35,604", "7,787", "49,36,957"],
          ["9", "43,391", "35,630", "7,761", "49,29,196"],
          ["10", "43,391", "35,656", "7,735", "49,21,461"],
          ["11", "43,391", "35,683", "7,708", "49,13,753"],
          ["12", "43,391", "35,709", "7,682", "49,06,071"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
            ["1", "43,391", "35,417", "7,974", "49,92,026"],
            ["2", "43,391", "35,444", "7,947", "49,84,079"],
            ["3", "43,391", "35,471", "7,920", "49,76,159"],
            ["4", "43,391", "35,497", "7,894", "49,68,265"],
            ["5", "43,391", "35,524", "7,867", "49,60,398"],
            ["6", "43,391", "35,551", "7,840", "49,52,558"],
            ["7", "43,391", "35,577", "7,814", "49,44,744"],
            ["8", "43,391", "35,604", "7,787", "49,36,957"],
            ["9", "43,391", "35,630", "7,761", "49,29,196"],
            ["10", "43,391", "35,656", "7,735", "49,21,461"],
            ["11", "43,391", "35,683", "7,708", "49,13,753"],
            ["12", "43,391", "35,709", "7,682", "49,06,071"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI (₹):</span> {emi}</div>
        <div><span className="font-semibold">   Interest (₹):</span> {interest}</div>
        <div><span className="font-semibold">Principal(₹):</span> {principal}</div>
        <div><span className="font-semibold"> Outstanding  (₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Home Loan EMI
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <ol className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
                <li><strong>Loan Amount:</strong> The total loan you borrow has a direct impact on your EMI. A higher principal loan amount will result in a proportionately larger EMI, especially if the interest rate and tenure remain unchanged.</li>
                <li><strong>Interest Rate:</strong> Even a slight variation in the interest rate—say 0.5%—can lead to a noticeable difference in your monthly EMI and total loan repayment. Choosing between fixed and floating rates also affects long-term EMI stability.</li>
                <li><strong>Loan Tenure:</strong> A longer repayment tenure reduces your monthly EMI burden, making it more affordable month-to-month. However, it increases the total interest outgo over the life of the loan, making the loan more expensive in the long run.</li>
                <li><strong>Processing Fees:</strong> Though it doesn’t directly influence your EMI amount, processing fees add to your upfront cost. It can slightly impact your initial budget and should be considered when calculating total cost of borrowing.</li>
                <li><strong>Prepayments:</strong> Making part-prepayments during the loan tenure helps in reducing the principal amount. This leads to a decrease in the remaining interest payable and future EMIs, or a shorter loan tenure, depending on lender terms.</li>
                <li><strong>Credit Score:</strong> A high credit/CIBIL score (usually 750+) shows financial discipline and increases your chances of securing a lower interest rate. A lower rate means reduced EMIs and overall loan cost.</li>
                <li><strong>Income & Profile:</strong> Lenders evaluate your income stability, job profile, and existing liabilities. A steady and high income with fewer liabilities can fetch you better interest rates and favorable terms, indirectly reducing your EMI burden.</li>
              </ol>
            </p>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h1 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default IciciHomeLoanEmiCalculator   ;
